import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatBotComponent } from './chatbot.component';
import { FormsModule } from '@angular/forms';
import { CoreModule } from '../core/core.module';
import { ClickOutsideModule } from 'ng-click-outside';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CoreModule,
    ClickOutsideModule,
    SharedModule,
    RouterModule
  ],
  declarations: [ChatBotComponent],
  exports: [ChatBotComponent]
})
export class ChatBotModule { }
